import { Tag } from '@adminModels';
import { CreateTagData, UpdateTagData } from '@adminStore/tags';
import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ApiConfiguration } from '@klubovna/api-client';
import {
  tagsControllerCreate,
  TagsControllerCreate$Params,
  tagsControllerDelete,
  tagsControllerFindAllAdmin,
  tagsControllerFindOne,
  tagsControllerUpdate,
  TagsControllerUpdate$Params,
} from '@klubovna/api-client';
import { PaginatedResponse, toPaginatedResponse } from '@klubovna/api-client';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

export interface TagsQueryParams {
  page?: number;
  limit?: number;
  search?: string;
  isActive?: boolean;
  sortBy?: 'nameSk' | 'nameEn' | 'createdAt';
  sortOrder?: 'ASC' | 'DESC';
}

@Injectable({
  providedIn: 'root',
})
export class TagsApiService {
  private http = inject(HttpClient);
  private apiConfig = inject(ApiConfiguration);

  findAll(params?: TagsQueryParams): Observable<PaginatedResponse<Tag>> {
    const apiParams = {
      page: params?.page,
      limit: params?.limit,
      search: params?.search,
      isActive: params?.isActive,
      sortBy: params?.sortBy,
      sortOrder: params?.sortOrder,
    };
    return tagsControllerFindAllAdmin(this.http, this.apiConfig.rootUrl, apiParams)
      .pipe(map(response => toPaginatedResponse<Tag>(response.body)));
  }

  findOne(id: string): Observable<Tag> {
    return tagsControllerFindOne(this.http, this.apiConfig.rootUrl, { id })
      .pipe(map(response => response.body as Tag));
  }

  create(tagData: CreateTagData): Observable<Tag> {
    const params: TagsControllerCreate$Params = {
      body: tagData,
    };
    return tagsControllerCreate(this.http, this.apiConfig.rootUrl, params)
      .pipe(map(response => response.body as Tag));
  }

  update(id: string, tagData: UpdateTagData): Observable<Tag> {
    const params: TagsControllerUpdate$Params = {
      id,
      body: tagData,
    };
    return tagsControllerUpdate(this.http, this.apiConfig.rootUrl, params)
      .pipe(map(response => response.body as Tag));
  }

  delete(id: string): Observable<void> {
    return tagsControllerDelete(this.http, this.apiConfig.rootUrl, { id })
      .pipe(map(() => undefined));
  }
}
